import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconAlignRight } from '@tabler/icons-react';

/**
 * A button that allows the user to align the selected text to the right.
 */
export default function AlignRight({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconAlignRight />}
      label="Zarovnať doprava"
      shortcut="Ctrl + Shift + R"
      active={editor?.isActive({ textAlign: 'right' })}
      onClick={() => editor?.chain().focus().setTextAlign('right').run()}
    />
  );
}
